export const REQUEST_NOTIFICATION_DETAIL = "request_notification_detail"
export const FETCH_MAIL_DETAIL_SUCCESS = "fetch_mail_detail_success"
export const FETCH_MAIL_DETAIL_FAILURE = "fetch_mail_detail_failure"
export const MAIL_ACTION_CHANGES = "mail_action_changes"

export const CLEAR_MAIL_DETAIL_STATE = "clear_mail_detail_state"